import { render, staticRenderFns } from "./pagination1.vue?vue&type=template&id=3082fe32&scoped=true&"
import script from "./pagination1.vue?vue&type=script&lang=js&"
export * from "./pagination1.vue?vue&type=script&lang=js&"
import style0 from "./pagination1.vue?vue&type=style&index=0&id=3082fe32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082fe32",
  null
  
)

export default component.exports